module.exports = __webpack_public_path__ + "img/youtube.40aca88b.svg";